export const ANTIRUG_CA = 'ts3foLrNUMvwdVeit1oNeLWjYk7e4qsn8PqSsqRpump';
